export default __webpack_public_path__ + "static/media/DYST.31a0da88.png";